import { useEffect, useState } from 'react';
import { api, ApiError } from '@/lib/api';
import type { FlightDirection, FlightScheduleResponse } from '@/types/api';

export function useFlightSchedule(date: string | null, travelers: number, direction: FlightDirection) {
  const [data, setData] = useState<FlightScheduleResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!date) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    setData(null);
    api
      .get<FlightScheduleResponse>(
        `/flights/schedule?date=${date}&direction=${direction}&travelers=${travelers}`,
      )
      .then((res) => !cancelled && setData(res))
      .catch((err) => {
        if (cancelled) return;
        if (err instanceof ApiError) {
          setError(err.message);
        } else {
          setError('Live flight information is temporarily unavailable.');
        }
      })
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [date, travelers, direction]);

  return { data, error, loading };
}
